const get = require('lodash/get');

const inject = ['config', '$http', 'apiUrls', 'caseConversionService', '$q'];

function ApiService(msiConfig, $http, apiUrls, caseConversionService, $q) {
  function defaultConfig() {
    return {
      responseType: 'json',
      headers: {
        'Authorization': angular.toJson(msiConfig.auth)
      }
    };
  }

  function jsonpConfig() {
    return {
      params: {
        ts: msiConfig.auth.ts,
        sig: msiConfig.auth.sig,
        merchant_id: msiConfig.auth.public_id,
        public_id: msiConfig.auth.public_id,
        merchant_user_id: msiConfig.auth.sig_field,
        sig_field: msiConfig.auth.sig_field
      }
    };
  }

  function Api(paramAuth) {
    this.get = function(url, config = {}) {
      config.method = 'GET';

      return this.request(url, config);
    };

    this.post = function(url, data, config = {}) {
      config.data = data;
      config.method = 'POST';

      return this.request(url, config);
    };

    this.put = function(url, data, config = {}) {
      config.data = data;
      config.method = 'PUT';

      return this.request(url, config);
    };

    this.request = function(url, config = {}) {
      const deferred = $q.defer();
      try {
        const baseConfig = {
          method: config.method || 'GET',
          url: apiUrls.masterDbUrl + url
        };

        const methodConfig = paramAuth ? jsonpConfig() : defaultConfig();

        const httpConfig = angular.merge(baseConfig, methodConfig, config);

        deferred.resolve($http(httpConfig));
      }
      catch (e) {
        deferred.reject(e);
      }

      const existsThenReject = path => (data) => {
        const obj = get(data, path);
        return obj ? $q.reject(obj) : data;
      };

      let promise = deferred.promise
        .then(response => response.data)
        .then(existsThenReject('error'))
        .then(existsThenReject('error_message'))
        .then(existsThenReject('errors.__all__'));

      if (!config.noCamelCase) {
        promise = promise.then(data => caseConversionService.convertObjectPropertiesToCamel(data));
      }

      return promise;
    };
  }

  const regularApi = new Api();

  regularApi.paramAuth = new Api(true);

  return regularApi;
}

ApiService.$inject = inject;

module.exports = ApiService;
